var Partner = /* @__PURE__ */ ((Partner2) => {
  Partner2[Partner2["IBANKING"] = 0] = "IBANKING";
  Partner2[Partner2["FEDERATION"] = 1] = "FEDERATION";
  Partner2[Partner2["CONSUMERAPP"] = 2] = "CONSUMERAPP";
  return Partner2;
})(Partner || {});

export { Partner };
